import PropTypes from 'prop-types';
import GoogleLoginButton from '../components/login/GoogleLoginButton.jsx';
import eAssistLogo from '../assets/eAssist-icon.png';

/**
 * @param {Object} props
 * @param {boolean} [props.executivePortal] - Simplified entry for Executive Pulse bookmark URL
 */
const LoginPage = ({ executivePortal = false }) => {
    return (
        <div id="login" className="login-spacing">
            <div className="register">
                <img
                    className="site__logo"
                    src={eAssistLogo}
                    alt="Eassist Icon"
                />
                <h2 id="sign_in">
                    {executivePortal ? 'Executive Pulse' : 'Sign In'}
                </h2>
                {executivePortal && (
                    <p
                        style={{
                            textAlign: 'center',
                            color: '#6b7280',
                            fontSize: '0.95rem',
                            marginBottom: '1rem',
                            maxWidth: '320px'
                        }}>
                        Sign in with your eAssist Google account to view the
                        leadership dashboard.
                    </p>
                )}
                <GoogleLoginButton />
            </div>
        </div>
    );
};

LoginPage.propTypes = {
    executivePortal: PropTypes.bool
};

export default LoginPage;
